import { render } from "./CertHygienePending.vue?vue&type=template&id=51a2b714&scoped=true"
import script from "./CertHygienePending.vue?vue&type=script&lang=js"
export * from "./CertHygienePending.vue?vue&type=script&lang=js"

import "./CertHygienePending.vue?vue&type=style&index=0&id=51a2b714&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a2b714"]])

export default __exports__